// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pw-0";
export var animationContainer = "_pw-1";
export var itemPrice = "_pw-a";
export var itemizedContent = "_pw-9";
export var itemizedHeader = "_pw-7";
export var itemizedRow = "_pw-8";
export var itemizedSection = "_pw-6";
export var modalContent = "_pw-2";
export var orderName = "_pw-3";
export var refundOption = "_pw-4";
export var refundOptionsContainer = "_pw-5";
export var shippingLabel = "_pw-b";
export var totalRow = "_pw-c";